import { getQuery } from 'sutils';
import { isMobile } from '@src/slide/infrastructure/module/independent/agent/common';
import { ISnackbarAction } from '@tencent/dui/lib/components/Snackbar/interface';
import i18n from '@i18next/i18n';
import { getRedirectUrl, openUrlWithCheck } from '@src/js/common/utils';
import CommonTips, { CommonTipsType } from '@src/framework/frame/components/common-tips';

export function showFirstScreenTip() {
    // 如果当前文档是从drive转化到在线编辑的，那么就显示提醒
    const isFromDrive = getQuery('qq_doc_source') === 'file';
    // 思维导图工具转slide https://docs.qq.com/open/toolkit/mind-to-doc.html
    const isFromMind = getQuery('isexported') === 'true';
    if (!isFromDrive && !isFromMind) return;

    const parentId = getQuery('parentId') || getQuery('folder_id');
    const basePath = isMobile() ? 'desktop/m' : 'desktop';
    const { hostname } = window.location;
    const padId = window.clientVars?.padId;

    let tip = '';
    let closable = true;
    let duration = 6000;
    let customerActions: ISnackbarAction[] | undefined = undefined;
    if (isFromDrive) {
        tip = i18n.t('已转为腾讯文档，编辑内容将在线保存');
    }
    if (isFromMind) {
        tip = i18n.t('转换完成，可在「我的应用文件」查看。');
        closable = false;
        duration = 8000;
        customerActions =  [{
            text: i18n.t('查看'),
            onClick: () => {
                openUrlWithCheck(getRedirectUrl(`https://${
                    hostname}/${
                    basePath}/mydoc/folder/${
                    parentId}?hl_file_id=${
                    padId}&qq_doc_source=file`));
            },
        }];
    }

    CommonTips.getInstance().show({
        message: tip,
        commonTipsType: CommonTipsType.SUCCESS,
        customerActions,
        autoClose: true,
        closable,
        onlyShowOne: true,
        duration,
    });
}
